import * as React from 'react';
import { Component } from 'react';
import BPromise from 'bluebird';
import Lazy from 'lazy.js';
import { parse } from 'query-string';
import { Grid2 } from 'Src/components/Grid/Grid2';
import { Loader } from 'Src/components/Loader/Loader';
import { AppUser } from 'Src/views/App/App';
import propz from 'propz';
import {
  ColumnDefinition,
  getFilters2,
  getServerQueryFilter2,
  isFilterExist2,
  isSortExist,
  TABLE_SORT_DIRECTION
} from 'Src/helpers/table/table';
import { SchoolForm } from 'Src/models/form';
import { SchoolUnionSchoolFormForm } from 'Src/components/SchoolUnionSchoolFormForm/SchoolUnionSchoolFormForm';
import { Button } from 'Src/components/Button/Button';
import { DATE_INTERVAL, FILTER_TYPE, FIRST_PAGE, DEFAULT_LIMIT, DEFAULT_SKIP, LIMIT } from 'Src/consts/table';
import { History, Location } from 'history';
import { getOrder, getSearchFilter, getSearchOrder, getServerFieldSectionWhere } from 'Src/helpers/table/table';
import {
  getAllSchoolUnionSchoolForms,
  getSchoolUnionSchoolForms,
  getSchoolUnionSchoolFormsCount,
  createSchoolUnionSchoolForm,
  deleteSchoolUnionSchoolForm,
  updateSchoolUnionSchoolForm,
  getSchoolUnionSchoolStudentsCount
} from 'Src/helpers/service/adminSU/schoolStudentsTable';
import {
  getSelectOptionForAge,
  getSelectOptionForForms,
  getSelectOptionForBooleanQuestion
} from 'Src/helpers/table/select';
import { GenericSummary } from 'Src/components/GenericSummary/GenericSummary';
import { getSchoolFromSU } from 'Src/helpers/service/adminSU/schoolAdminsTable';
import { SimpleModal } from 'Src/components/SimpleModal/SimpleModal';
import { FormSummary } from 'Src/components/FormSummary/FormSummary';
import { FORM_TABS } from 'Src/consts/form';
import { ResizablePanel } from 'Src/components/ResizablePanel/ResizablePanel';
import { AGE_GROUPS } from 'Src/consts/school';
import { getPagesCount } from 'Src/helpers/table/table';

const COLUMNS: ColumnDefinition[] = [
  {
    text: 'Name',
    field: 'name',
    isSort: true,
    type: FILTER_TYPE.TEXT,
    accessor: ['name']
  },
  {
    text: 'Age Group',
    field: 'ageGroup',
    isSort: false,
    type: FILTER_TYPE.MULTISELECT,
    accessor: ['ageGroup']
  }
];

interface Props {
  user: AppUser;
  history: History;
  location: Location;
}

interface State {
  items: SchoolForm[];
  currentPage: number;
  selectedItems: SchoolForm[];
  sortDirection: TABLE_SORT_DIRECTION;
  sortColumnsName: string;
  isShowFilter: boolean;
  isDataFiltered: boolean;
  filters: any;
  isLoading: boolean;
  isSelectAllChecked: boolean;
  totalWithFilters: number;
  total: number;
  basePath: string;
  forms: SchoolForm[];
  deleteFormConfirmationModalText: string;
  deleteFormProhibitionModalText: string;
  formsWithoutStudents: SchoolForm[];

  isCreateOrEditFormModalOpen: boolean;
  isDeleteFormConfirmationModalOpen: boolean;
  isDeleteFormProhibitionModalOpen: boolean;

  school: any;
  schoolName: string;
}

interface StudentCountResponse {
  count: number | { count: number };
}

export class SchoolForms extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      items: [],
      currentPage: FIRST_PAGE,
      selectedItems: [],
      sortDirection: '',
      sortColumnsName: '',
      isShowFilter: false,
      isDataFiltered: false,
      filters: {},
      isLoading: false,
      isSelectAllChecked: false,
      totalWithFilters: 0,
      total: 0,
      basePath: '',
      forms: [],
      deleteFormConfirmationModalText: '',
      deleteFormProhibitionModalText: '',
      formsWithoutStudents: [],

      isCreateOrEditFormModalOpen: false,
      isDeleteFormConfirmationModalOpen: false,
      isDeleteFormProhibitionModalOpen: false,

      school: undefined,
      schoolName: ''
    };
  }

  getSchoolId(): string {
    const { location } = this.props;
    const searchParams = parse(location.search);
    const schoolId = searchParams.school || this.state.school?.id;
    return schoolId;
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });

    this.setAdditionalItems().then(res => {
      this.setItems();
    });
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.location.search !== this.props.location.search) {
      this.setState({
        isLoading: true
      });
      this.setItems();
    }
  }

  setAdditionalItems() {
    const { user } = this.props;
    const schoolId = this.getSchoolId();

    return BPromise.all([getSchoolFromSU(user, schoolId), getAllSchoolUnionSchoolForms(user, schoolId)]).then(
      ([school, forms]) => {
        this.setState({
          school: school,
          schoolName: school.name,
          forms: forms
        });
        return true;
      }
    );
  }

  setItems() {
    const { history, user } = this.props;
    const schoolId = this.getSchoolId();

    getSchoolFromSU(user, schoolId).then(school => {
      this.setState({ school });
    });

    const search = parse(history.location.search);
    const page = typeof search.page !== 'undefined' ? Number(search.page) : FIRST_PAGE;

    let sortDirection: TABLE_SORT_DIRECTION = '';
    let sortColumnsName = '';

    if (typeof search.order === 'string') {
      [sortColumnsName, sortDirection] = search.order.split(':');
    }

    const sortByFieldExist = sortColumnsName !== '';
    const sortDirectionExist = sortDirection !== '';

    const filters = getFilters2(COLUMNS, search);

    const isShowFilter = false;
    const isDataFiltered = isFilterExist2(filters);

    // TODO_002 fix it
    const options = {
      forms: this.state.forms
    };
    const where = getServerFieldSectionWhere(filters, options);

    const order = sortByFieldExist && sortDirectionExist ? `${sortColumnsName} ${sortDirection}` : undefined;
    const serverQueryFilter = getServerQueryFilter2(page, where, order);

    const getFormsPromise = getSchoolUnionSchoolForms(user, schoolId, serverQueryFilter);
    const getFormCountPromise = getSchoolUnionSchoolFormsCount(user, schoolId, where);
    const getFormsTotalCountPromise = getSchoolUnionSchoolFormsCount(user, schoolId);

    return BPromise.all([getFormCountPromise, getFormsTotalCountPromise, getFormsPromise]).then(
      ([totalWithFiltersObj, totalObj, forms]) => {
        this.setState({
          currentPage: page,
          sortDirection: sortDirection,
          sortColumnsName: sortColumnsName,
          isShowFilter: isShowFilter,
          isDataFiltered: isDataFiltered,
          filters: filters,
          items: forms,
          totalWithFilters: totalWithFiltersObj.count,
          total: totalObj.count,
          basePath: history.location.pathname,
          isLoading: false
        });

        return true;
      }
    );
  }

  setCurrentPageParams = (currentPage: number): void => {
    let search: string[] = [];

    const { filters, sortColumnsName, sortDirection } = this.state;

    if (currentPage !== 1) {
      search.push(`page=${currentPage}`);
    }

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onItemClick = (index: number): void => {
    const { items, selectedItems } = this.state;
    const selectedForm = items[index];

    const selectedFormIndex = selectedItems.findIndex(form => selectedForm.id === form.id);
    let selectedFormUpdated = [...selectedItems];

    if (selectedFormIndex !== -1) {
      selectedFormUpdated.splice(selectedFormIndex, 1);
    } else {
      selectedFormUpdated.push(selectedForm);
    }

    this.setState({
      selectedItems: selectedFormUpdated
    });
  };

  onSelectAllOnPageClick = (): void => {
    const { items, selectedItems } = this.state;

    const formsFiltered = items.filter(form => {
      return selectedItems.every(selectedForm => selectedForm.id !== form.id);
    });

    const selectedForms = [...selectedItems, ...formsFiltered];

    this.setState({
      selectedItems: selectedForms,
      isSelectAllChecked: true
    });
  };

  onSelectAllClick = (): void => {
    const { selectedItems, filters, forms } = this.state;
    const schoolId = this.getSchoolId();

    this.setState({
      isLoading: true
    });

    const user = this.props.user;

    const options = {
      forms: forms
    };

    const where = getServerFieldSectionWhere(filters, options);

    getAllSchoolUnionSchoolForms(user, schoolId, where).then(forms => {
      const formsFiltered = forms.filter(form => {
        return selectedItems.every(selectedForm => selectedForm.id !== form.id);
      });

      const selectedForms = [...selectedItems, ...formsFiltered];

      this.setState({
        selectedItems: selectedForms,
        isSelectAllChecked: true,
        isLoading: false
      });
    });
  };

  onUnselectAllClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });
  };

  onTableSortClick = (sortField: string): void => {
    const { sortDirection, sortColumnsName, filters } = this.state;

    const order = getOrder(sortField, sortDirection, sortColumnsName);

    let search: string[] = [];
    search.push(`order=${sortField}:${order}`);

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onTableFilterChange = (event, filterField: string, options?): void => {
    const filterValue = event.target.value;
    const filters = this.state.filters;
    const currentFilterField = filters[filterField];

    let nextFilters = { ...filters };

    if (filterField === 'ageGroup') {
      nextFilters.ageGroup = [];
    }

    if (typeof options !== 'undefined') {
      switch (options) {
        case DATE_INTERVAL.FROM:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              from: filterValue
            }
          };
          break;
        case DATE_INTERVAL.TO:
          nextFilters = {
            ...nextFilters,
            [filterField]: {
              ...currentFilterField,
              to: filterValue
            }
          };
          break;
      }
    } else {
      const filter = COLUMNS.find(col => col.field === filterField);
      const filterType = filter.type;

      if (filterType === FILTER_TYPE.MULTISELECT) {
        const options = event.target.options;
        const value = [];
        for (let i = 0; i < options.length; i++) {
          if (options[i].selected) {
            value.push(options[i].value);
          }
        }
        nextFilters = {
          ...nextFilters,
          [filterField]: value
        };
      } else {
        nextFilters = {
          ...nextFilters,
          [filterField]: filterValue
        };
      }
    }

    this.setState({
      filters: nextFilters
    });
  };

  onApplyFilterClick = (): void => {
    const { filters, sortDirection, sortColumnsName } = this.state;
    let search: string[] = [];

    if (isSortExist(sortDirection, sortColumnsName)) {
      search.push(getSearchOrder(sortDirection, sortColumnsName));
    }

    const isFilter = isFilterExist2(filters);

    if (isFilter) {
      search.push(getSearchFilter(filters));
    }

    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: search.join('&')
    });
  };

  onClearFilterClick = (): void => {
    this.setState({
      selectedItems: [],
      isSelectAllChecked: false
    });

    this.props.history.push({
      pathname: this.state.basePath,
      search: ''
    });
  };

  onCancelFilterClick = (): void => {
    this.setState({ isShowFilter: false, filters: getFilters2(COLUMNS, parse(this.props.history.location.search)) });
  };

  onTableFilterClick = (event): void => {
    event.preventDefault();

    const isShowFilter = this.state.isShowFilter;

    this.setState({
      isShowFilter: !isShowFilter
    });
  };

  onSaveButtonClick = (data): void => {
    const { user, history } = this.props;
    const { school, total } = this.state;

    if (!school || !school.ageGroupsNaming) {
      return;
    }

    const schoolId = school.id;
    const ageGroupsNaming = school.ageGroupsNaming;

    this.setState({
      isLoading: true
    });

    const { name, ageGroup } = data;
    const ageGroups = propz.get(AGE_GROUPS, [ageGroupsNaming], []);
    const age = ageGroups.findIndex(group => group === ageGroup);
    const formToTransfer = {
      age: age,
      name: name.trim()
    };

    switch (this.state.selectedItems.length) {
      case 0: {
        createSchoolUnionSchoolForm(user, schoolId, formToTransfer).then((form: SchoolForm) => {
          const lastPage = getPagesCount(total, LIMIT);

          history.push({
            pathname: this.state.basePath,
            search: `page=${lastPage}`
          });

          this.setState({
            isCreateOrEditFormModalOpen: false,
            selectedItems: [form]
          });

          this.setItems();
        });
        break;
      }
      case 1: {
        const formId = this.state.selectedItems[0].id;
        updateSchoolUnionSchoolForm(user, schoolId, formId, formToTransfer).then((form: SchoolForm) => {
          this.setState({
            isCreateOrEditFormModalOpen: false,
            selectedItems: [form]
          });

          this.setItems();
        });
        break;
      }
    }
  };

  onCancelButtonClick = (): void => {
    this.setState({
      isCreateOrEditFormModalOpen: false
    });
  };

  onTabClick = (event, index: number) => {
    event.preventDefault();

    //TODO_001 fix it
    this.setState({
      total: index
    });
  };

  onEditFormClick = event => {
    event.preventDefault();

    this.setState({
      isCreateOrEditFormModalOpen: true
    });
  };

  onBackClick = () => {
    const { history } = this.props;
    const savedState = sessionStorage.getItem('schoolsState');

    let search = '';

    if (savedState) {
      const stateObj = JSON.parse(savedState);
      const { currentPage, filters, sortDirection, sortColumnsName, selectedSchool } = stateObj;

      if (currentPage !== 1) {
        search += `page=${currentPage}`;
      }

      if (isSortExist(sortDirection, sortColumnsName)) {
        search += `&${getSearchOrder(sortDirection, sortColumnsName)}`;
      }

      if (isFilterExist2(filters)) {
        search += `&${getSearchFilter(filters)}`;
      }

      if (selectedSchool) {
        search += `&school=${selectedSchool.id}`;
      }

      this.setState({ selectedItems: [selectedSchool] });
    }

    history.push({
      pathname: '/schools',
      search
    });
  };

  getSummaryTabs(): React.ReactNode {
    const { selectedItems, items, forms } = this.state;

    switch (true) {
      case selectedItems.length === 1:
        return <FormSummary form={selectedItems[0]} />;
    }
  }

  renderForm() {
    const { isCreateOrEditFormModalOpen, selectedItems, school } = this.state;
    const { user } = this.props;

    if (!school) {
      return null;
    }

    switch (selectedItems.length) {
      case 0:
        return (
          <SimpleModal isOpen={isCreateOrEditFormModalOpen} title={'Create form'}>
            <SchoolUnionSchoolFormForm
              isOpen={isCreateOrEditFormModalOpen}
              onCloseClick={this.onCancelButtonClick}
              onFormCreated={this.onSaveButtonClick}
              user={user}
              selectedSchool={school}
            />
          </SimpleModal>
        );
      case 1:
        return (
          <SimpleModal isOpen={isCreateOrEditFormModalOpen} title={'Edit form'}>
            <SchoolUnionSchoolFormForm
              isOpen={isCreateOrEditFormModalOpen}
              onCloseClick={this.onCancelButtonClick}
              onFormCreated={this.onSaveButtonClick}
              form={selectedItems[0]}
              user={user}
              selectedSchool={school}
            />
          </SimpleModal>
        );
    }
  }

  onCreateFormClick = () => {
    this.setState({
      isCreateOrEditFormModalOpen: true
    });
  };

  onRemoveFormClick = () => {
    const { user } = this.props;
    const { selectedItems } = this.state;
    const schoolId = this.getSchoolId();

    const selectedItemsCount = selectedItems.length;

    const promises = selectedItems.map(item => {
      const { id: formId } = item;
      return getSchoolUnionSchoolStudentsCount(user, schoolId, { formId });
    });

    this.setState({ isLoading: true });

    BPromise.all(promises)
      .then((studentsCountsArray: StudentCountResponse[]) => {
        const formsWithStudents = [];
        const formsWithoutStudents = [];

        studentsCountsArray.forEach((item, index) => {
          const count = typeof item.count === 'object' && 'count' in item.count ? item.count.count : item.count;
          const form = selectedItems[index];
          const formName = selectedItems[index].name;

          if (count && count > 0) {
            formsWithStudents.push(formName);
          } else {
            formsWithoutStudents.push(form);
          }
        });

        if (formsWithStudents.length > 0 && formsWithoutStudents.length === 0) {
          this.setState({
            deleteFormProhibitionModalText: `The form(s) ${formsWithStudents.join(
              ', '
            )} cannot be deleted as they have students linked to them.`,
            formsWithoutStudents: [],
            isDeleteFormProhibitionModalOpen: true,
            isLoading: false
          });
        } else if (formsWithStudents.length === 0 && formsWithoutStudents.length > 0) {
          this.setState({
            deleteFormConfirmationModalText: `Are you sure you want to delete ${formsWithoutStudents.length} form(s)?`,
            formsWithoutStudents,
            isDeleteFormConfirmationModalOpen: true,
            isLoading: false
          });
        } else {
          this.setState({
            deleteFormConfirmationModalText: `Are you sure you want to delete ${
              formsWithoutStudents.length
            } form(s)? Note: ${formsWithStudents.join(', ')} cannot be deleted as they have students linked to them.`,
            formsWithoutStudents,
            isDeleteFormConfirmationModalOpen: true,
            isLoading: false
          });
        }
      })
      .catch(error => {
        console.error('Error checking student counts:', error);
        this.setState({ isLoading: false });
      });
  };

  removeForm = () => {
    const { user } = this.props;
    const { formsWithoutStudents } = this.state;
    const schoolId = this.getSchoolId();

    this.setState({ isLoading: true });

    const promises = formsWithoutStudents.map(form => {
      const { id } = form;
      return deleteSchoolUnionSchoolForm(user, schoolId, id);
    });

    BPromise.all(promises)
      .then(() => {
        this.setState({
          selectedItems: [],
          isDeleteFormConfirmationModalOpen: false
        });

        this.setItems();
      })
      .catch(error => {
        this.setState({ isLoading: false });
      });
  };

  openDeleteFormConfirmationModal = (): void => {
    this.setState({
      isDeleteFormConfirmationModalOpen: true
    });
  };

  closeDeleteFormConfirmationModal = (): void => {
    this.setState({
      isDeleteFormConfirmationModalOpen: false
    });
  };

  renderDeleteFormConfirmationModal() {
    const { selectedItems, isDeleteFormConfirmationModalOpen, deleteFormConfirmationModalText } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteFormConfirmationModalOpen}
        title={'Remove form'}
        body={deleteFormConfirmationModalText}
        buttonText={'Delete'}
        onButtonClick={this.removeForm}
        onCloseClick={this.closeDeleteFormConfirmationModal}
      />
    );
  }

  openDeleteFormProhibitionModal = (): void => {
    this.setState({
      isDeleteFormProhibitionModalOpen: true
    });
  };

  closeDeleteFormProhibitionModal = (): void => {
    this.setState({
      isDeleteFormProhibitionModalOpen: false
    });
  };

  renderDeleteFormProhibitionModal() {
    const { isDeleteFormProhibitionModalOpen, deleteFormProhibitionModalText } = this.state;

    return (
      <SimpleModal
        isOpen={isDeleteFormProhibitionModalOpen}
        title={'Action is prohibited'}
        body={deleteFormProhibitionModalText}
        onCloseClick={this.closeDeleteFormProhibitionModal}
      />
    );
  }

  renderSummary() {
    const { selectedItems } = this.state;
    const isOneItemSelected = selectedItems.length === 1;

    if (!isOneItemSelected) {
      return <div className="font-weight-bold">Select a form above</div>;
    }

    const summaryTabs = this.getSummaryTabs();

    const isShowEditButton = selectedItems.length === 1;

    return (
      <GenericSummary onTabClick={this.onTabClick} tabs={FORM_TABS} currentTabIndex={0}>
        {isShowEditButton && <Button onClick={this.onEditFormClick} text={'Edit'} customClass={'mt-3 mb-3'} />}
        {summaryTabs}
      </GenericSummary>
    );
  }

  stylizeCell = cell => {
    const isItemWithStudents = cell.rowData.isContainStudents;
    return isItemWithStudents ? '' : 'text-danger';
  };

  render() {
    const {
      items,
      sortDirection,
      sortColumnsName,
      isShowFilter,
      isDataFiltered,
      selectedItems,
      filters,
      isLoading,
      isSelectAllChecked,
      currentPage,
      totalWithFilters,
      isCreateOrEditFormModalOpen,
      isDeleteFormConfirmationModalOpen,
      forms,
      schoolName,
      school
    } = this.state;

    if (isLoading) {
      return <Loader />;
    }

    const classes = isCreateOrEditFormModalOpen || isDeleteFormConfirmationModalOpen ? 'mt-3 modal-open' : 'mt-3';

    const actionItems = school?.studentImportForAdminAllowed
      ? [
          {
            itemText: 'Create form',
            onItemClick: this.onCreateFormClick,
            isActive: selectedItems.length === 0
          },
          {
            itemText: 'Remove form',
            onItemClick: this.onRemoveFormClick,
            isActive: selectedItems.length > 0
          }
        ]
      : [];
    const ageGroupsNaming = school?.ageGroupsNaming || '';

    const filterOptions = {
      ageGroup: getSelectOptionForAge(forms, ageGroupsNaming)
    };

    return (
      <div className={classes}>
        <h2>{schoolName} Forms</h2>
        <Button onClick={this.onBackClick} text={'Back'} customClass={'mt-3 mb-3'} />

        {/*Place for render modal windows*/}
        {this.renderDeleteFormConfirmationModal()}
        {this.renderDeleteFormProhibitionModal()}
        {this.renderForm()}
        <div className="row">
          <div className="col-md-12">
            <ResizablePanel>
              <Grid2
                dataItems={items}
                filters={filters}
                currentPage={currentPage}
                total={totalWithFilters}
                isSelectAllChecked={isSelectAllChecked}
                isDataFiltered={isDataFiltered}
                sortDirection={sortDirection}
                sortColumnsName={sortColumnsName}
                isShowFilter={isShowFilter}
                dataItemsSelected={selectedItems}
                columns={COLUMNS}
                actionItems={actionItems}
                options={filterOptions}
                stylizeCell={this.stylizeCell}
                onItemClick={this.onItemClick}
                onSortClick={this.onTableSortClick}
                onApplyFilterClick={this.onApplyFilterClick}
                onClearFilterClick={this.onClearFilterClick}
                onCancelFilterClick={this.onCancelFilterClick}
                onTableFilterChange={this.onTableFilterChange}
                onTableFilterClick={this.onTableFilterClick}
                setCurrentPageParams={this.setCurrentPageParams}
                onSelectAllClick={this.onSelectAllClick}
                onSelectAllOnPageClick={this.onSelectAllOnPageClick}
                onUnselectAllClick={this.onUnselectAllClick}
                user={this.props.user}
              />
              {this.renderSummary()}
            </ResizablePanel>
          </div>
        </div>
      </div>
    );
  }
}


